module.exports = __webpack_public_path__ + "img/img19.66531273.svg";